/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import emptyImages from 'assets/img/empty-images.svg';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import word from 'assets/img/file_word.png';
import excel from 'assets/img/file_excel.png';
import pdf from 'assets/img/file_pdf.png';
import ppt from 'assets/img/file_pp.png';
import video from 'assets/img/file_video.png';
import other from 'assets/img/file_other.png';
import { isMobile } from 'react-device-detect';
import PreviewVideoWO from '../../../Work-Orders/Components/PreviewVideoWO';
import { PreviewImage } from 'components/PreviewImage';
import Linkify from 'react-linkify';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import Moment from 'moment';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
// import * as LotActionType from '../constants';
// const MAXIMUM_VIDEO_SIZE = 1024 * 1024 * 500;
class ViewDetailsCategoryItemsLot extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    onGetCategoryItemProfile: PropTypes.func,
    location: PropTypes.any,
    history: PropTypes.any,
    categoryItemProfile: PropTypes.object,
    categoryList: PropTypes.array,
    goToEditScreen: PropTypes.func,
    goToListScreen: PropTypes.func,
    itemId: PropTypes.string
  }
  constructor(props) {
    super(props);
    this.state = {
      category: null,
      cancelUploadList: {},
      deleteUploadList: {},
      imagePreview: null,
      showDialog: false
    };
  }

  componentDidMount() {
    this.props.onGetCategoryItemProfile(this.props.itemId);
  }

  onTogglePreviewImages = (url) => {
    this.setState({
      imagePreview: url
    });
  }

  onPreviewFilesAttachment = (file) => {
    const extension = file.fileName.split('.').pop().toLowerCase();
    const imageType = ['jpg', 'jpeg', 'png', 'gif'];
    const videoType = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
    if (imageType.includes(extension)) {
      this.setState({
        show: true,
        previewUrl: file.url
      });
    }
    if (extension === 'pdf') {
      this.setState({
        isPreviewPDF: file.url
      }, () => {
        if (isMobile) {
          window.open(this.state.isPreviewPDF, '_blank');
        }
      });
    }
    if (videoType.includes(extension)) {
      this.setState({
        showDialog: true,
        videoUrl: file.url
      });
    }
  }

  handleClose = () => {
    this.setState({ show: false, previewUrl: null });
  }

  handleCloseVideo = (callback) => {
    this.setState({ showDialog: false, videoUrl: null }, callback);
  }

  renderFileTypeIcon = (item) => {
    const extWord = ['doc', 'docx'];
    const extExcel = ['xls', 'xlsx'];
    const extPpt = ['ppt', 'pptx'];
    const extImage = ['jpg', 'jpeg', 'png', 'gif'];
    const extVideo = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
    const ext = item.fileName.split('.').pop().toLowerCase();
    if (extWord.includes(ext)) { return word; }
    else if (extExcel.includes(ext)) { return excel; }
    else if (extPpt.includes(ext)) { return ppt; }
    else if (extPpt.includes(ext)) { return ppt; }
    else if (extVideo.includes(ext)) { return video; }
    else if (ext === 'pdf') { return pdf; }
    else if (extImage.includes(ext)) { return item.url; }
    else { return other; }
  }

  renderFileUpload = () => {
    const { categoryItemProfile } = this.props;
    return (
      <ul className='inventory-attachments-files-list row'>
        {(categoryItemProfile && categoryItemProfile.attachments.length > 0) &&
          categoryItemProfile.attachments.map(file =>
            <li key={file.fileName}>
              <div style={{
                width: 50,
                height: 60,
                marginLeft: 15,
                marginRight: 10,
                borderRadius: 2,
                verticalAlign: 'top',
                backgroundImage: `url(${this.renderFileTypeIcon(file)})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'inline-block'
              }} onClick={() => this.onPreviewFilesAttachment(file)}/>
              <div style={{ display: 'inline-block', textOverflow: 'ellipsis', maxWidth: '80%', whiteSpace: 'nowrap', marginTop: '15px' }} className='file-info'>
                <span onClick={() => this.onPreviewFilesAttachment(file)} >{file.fileName}</span>
              </div>
              <div style={{display: 'inline-block', marginLeft: "10px"}} className='remove-button-wrapper-item' >
                <i className='fa fa-eye view-icon func-icon inventory-preview' onClick={() => this.onPreviewFilesAttachment(file)}/>
              </div>
              {/* <div style={{display: 'inline-block'}} className='remove-button-wrapper' onClick={() => this.onRemoveFiles(file.id)}>
                      <div className='remove-button icon-remove-ic' />
                    </div> */}
            </li>
          )}
      </ul>
    );
  }

  renderTextValue = value => {
    if (value) {
      return <Linkify><strong>{value}</strong></Linkify>;
    }

    return <span style={{ opacity: '.5' }}>(Not specified)</span>;
  }

  renderDateValue = value => {
    if (value) {
      return Moment(value).format('MM/DD/YYYY');
    }

    return <span style={{ opacity: '.5' }}>(Not specified)</span>;
  }

  renderCategoryList = (categories) => {
    if (!isEmpty(categories)) {
      return categories.join(', ');
    }

    return <span style={{ opacity: '.5' }}>(Not specified)</span>;
  }

  renderLocationList = (locations) => {
    if (!isEmpty(locations)) {
      return locations.map(l => l.hiTagLocationId).join(', ');
    }

    return <span style={{ opacity: '.5' }}>(Not specified)</span>;
  }

  renderInventoryWarrantyValue = profile => {
    if (profile.warrantyExpirationDateValue === null && profile.warrantyExpirationIntValue === null) {
      return <span style={{ opacity: '.5' }}>(Not specified)</span>;
    }

    if (profile.warrantyExpirationDateValue === null) {
      return <strong>{profile.warrantyExpirationIntValue} {profile.warrantyExpirationTimeUnit === 0 ? ((profile.warrantyExpirationIntValue > 1) ? 'months' : 'month') : ((profile.warrantyExpirationIntValue > 1) ? 'years' : 'year')} from {profile.warrantyExpirationType === 0 ? 'COE'
        : 'Purchase Date'
      }</strong>;
    }

    if (profile.warrantyExpirationDateValue !== null) {
      return <strong>{Moment(profile.warrantyExpirationDateValue).format('MM/DD/YYYY')}</strong>;
    }

    return '';
  }

  onClickBreadcrumb = () => {
    this.props.goToListScreen();
  }

  render() {
    if (!this.props.categoryItemProfile) {
      return null;
    }

    const { imagePreview } = this.state;
    const { categoryItemProfile } = this.props;
    const breadcrumbs = [
      { title: 'Inventory items', url: '/', onCustomAction: this.onClickBreadcrumb },
      { title: `${categoryItemProfile.name}`, url: '' }
    ];

    return (
      <React.Fragment>
        <div className='home-libraries-inventory container-fluid'>
          <h4 style={{ height: 30, marginTop: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{categoryItemProfile.name}</h4>
          <div><Breadcrumb breadcrumbs={breadcrumbs} /></div>
          {
            this.state.isPreviewPDF && !isMobile && [
              <embed src={this.state.isPreviewPDF} className='pdf-preview-dialog' ref={ref => { this.embedPreview = ref; }} />,
              <i onClick={() => this.setState({ isPreviewPDF: null })} className='close-embed-preview fa fa-close' />
            ]
          }
          {
            <PreviewImage
              show={this.state.show}
              imageUrl={this.state.previewUrl}
              handleClose={this.handleClose}
            />
          }
          {
            this.state.videoUrl && [
              <PreviewVideoWO
                // loading
                data={this.state.videoUrl}
                showDialog={this.state.showDialog}
                handleCloseVideo={this.handleCloseVideo}
              />
            ]
          }

          <div className='add-new-category-item row'>
            <div className='col-md-6 col-xs-6'>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>Name</label>
                  <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                    {this.renderTextValue(categoryItemProfile.name ? categoryItemProfile.name : null)}
                  </div>
                </div>
              </div>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>Inventory</label>
                  <div className=' col-sm-9 control-label name form-text-label'>
                    {this.renderCategoryList(categoryItemProfile.categories ? categoryItemProfile.categories : null)}
                  </div>
                </div>
              </div>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>MFG/Provider</label>
                  <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                    {this.renderTextValue(categoryItemProfile.mfg ? categoryItemProfile.mfg : null)}
                  </div>
                </div>
              </div>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>Model/Type</label>
                  <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                    {this.renderTextValue(categoryItemProfile.model ? categoryItemProfile.model : null)}
                  </div>
                </div>
              </div>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>MFG Links</label>
                  <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }} className='col-sm-9 control-label name form-text-label'>
                    {this.renderTextValue(categoryItemProfile.note ? categoryItemProfile.note : null)}
                  </div>
                </div>
              </div>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>Style</label>
                  <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                    {this.renderTextValue(categoryItemProfile.style ? categoryItemProfile.style : null)}
                  </div>
                </div>
              </div>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>Serial number</label>
                  <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                    {this.renderTextValue(categoryItemProfile.lot ? categoryItemProfile.lot.serialNumber : null)}
                  </div>
                </div>
              </div>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>Price/Service fee</label>
                  <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                    {this.renderTextValue(categoryItemProfile.lot ? categoryItemProfile.lot.serviceFee : null)}
                  </div>
                </div>
              </div>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>Purchase date</label>
                  <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                    {this.renderDateValue(categoryItemProfile.lot ? categoryItemProfile.lot.purchaseDate : null)}
                  </div>
                </div>
              </div>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>Locations</label>
                  <div className='over-flow-text col-sm-9 control-label name form-text-label'>
                    {this.renderLocationList(categoryItemProfile.lot ? categoryItemProfile.lot.tagLocations : null)}
                  </div>
                </div>
              </div>
              <div className='view-details'>
                <div className='row col-sm-12 margin-bottom-20'>
                  <label className='col-sm-3 font-normal control-label'>Limited warranty period</label>
                  <div className='col-sm-9 control-label name form-text-label'>
                    {this.renderInventoryWarrantyValue(categoryItemProfile ? categoryItemProfile : null)}
                  </div>
                </div>
              </div>
              <div style={{ margin: '15% 0 10%' }} className='row'>
                <div className='col-sm-6 col-xs-12'>
                  <button onClick={this.props.goToEditScreen} className='btn btn-primary btn-siteone'>Edit</button>
                </div>
              </div>
            </div>
            <div style={{ marginTop: -115 }} className='col-md-6 col-xs-6'>
              <div className='preview-inventory-items-image'>
                <div className='container-fluid'>
                  <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      {imagePreview && <img
                        className='empty-category-image'
                        src={imagePreview || !isEmpty(categoryItemProfile.images) ? imagePreview : emptyImages}
                        alt='no-files'
                      />}
                      {!imagePreview && <img
                        className='empty-category-image'
                        src={categoryItemProfile && categoryItemProfile.images.length ? categoryItemProfile.images[0].url : emptyImages}
                        alt='no-files'
                      />}
                    </div>
                  </div>
                </div>

                <div className='container-fluid'>
                  <div className='list-thumbnail-image-after-upload'>
                    <div className='row'>
                      {/* map img FIXME:*/}
                      <div style={{ height: 70, display: 'flex', justifyContent: 'center' }} className='col-md-12 col-sm-6 col-xs-12'>
                        {!isEmpty(categoryItemProfile.images) && (
                          categoryItemProfile.images.map((el, index) => {
                            return (
                              <div key={index} className='image-file-after-upload col-md-2 col-xs-4 col-lg-2'>
                                <img className='category-img-item' onClick={() => this.onTogglePreviewImages(el.url)} src={el.url} />
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* attachments */}
              <div className='row'>
                <div className='col-md-12 col-xs-12'>
                  <label className='font-normal'>
                    Attachments
                  </label>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 col-xs-12'>
                  <div style={{ marginLeft: -20 }} className='inventory-attachments-files-list container-fluid'>
                    {(categoryItemProfile && categoryItemProfile.attachments && categoryItemProfile.attachments.length) ? this.renderFileUpload() : ''}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    categoryList: state.LotStore.categoryList,
    categoryItemProfile: state.LotStore.categoryItemProfile
  };
};

export default withRouter(connect(mapStateToProps)(ViewDetailsCategoryItemsLot));



// WEBPACK FOOTER //
// ./src/Lots/Components/Inventory/item-view.js